import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setAuthorization } from "../helpers/api_helper";
import { useProfile } from "../Components/Hooks/UserHooks";
import { logoutUser } from "../slices/auth/login/thunk";

const AuthProtected = ({ children }) => {
  const dispatch = useDispatch();
  const { user: userProfile, loading, token } = useSelector(state => state.Login);

  useEffect(() => {
    if (userProfile && token) {
      setAuthorization(token);
    } else if (!loading && (!userProfile || !token)) {
      dispatch(logoutUser());
    }
  }, [token, userProfile, loading, dispatch]);

  // if (loading) {
  //   return <div className="text-center py-5">Checking authentication...</div>;
  // }

  if (!userProfile || !token) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default AuthProtected;
